module.exports = __webpack_public_path__ + "static/media/img_chinese.3490ef3f.png";